import React, { useState } from 'react';
import Modal from '../../../components/ui/Modal';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const ClientIntakeActionsModal = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState('actions');
  const [formData, setFormData] = useState({
    clientName: '',
    clientType: 'buyer',
    phone: '',
    email: '',
    budget: '',
    preferences: '',
    aiSuggest: false,
    autoMatch: false
  });

  const actions = [
    { id: 'ai-form', icon: 'FileText', label: 'نموذج ذكي تلقائي', color: '#3B82F6' },
    { id: 'quick-intake', icon: 'Zap', label: 'استقبال سريع', color: '#10B981' },
    { id: 'ai-match', icon: 'Target', label: 'مطابقة ذكية للعقارات', color: '#8B5CF6' },
    { id: 'preference-analysis', icon: 'BarChart3', label: 'تحليل التفضيلات', color: '#F59E0B' },
    { id: 'follow-up', icon: 'Calendar', label: 'جدولة متابعة تلقائية', color: '#06B6D4' },
    { id: 'duplicate-check', icon: 'Shield', label: 'فحص التكرار', color: '#EF4444' }
  ];

  const templates = [
    { id: 'buyer', name: 'نموذج مشتري', fields: ['budget', 'location', 'propertyType'] },
    { id: 'renter', name: 'نموذج مستأجر', fields: ['budget', 'duration', 'preferences'] },
    { id: 'investor', name: 'نموذج مستثمر', fields: ['investmentType', 'roi', 'timeline'] },
    { id: 'vip', name: 'نموذج VIP', fields: ['all', 'priority', 'dedicated'] }
  ];

  const handleAction = (actionId) => {
    console.log('Client intake action:', actionId);
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      title="استقبال العملاء - الإجراءات والقوالب"
      footer={null}
      icon={null}
      iconColor={null}
    >
      <div className="space-y-6">
        <div className="flex gap-2 border-b border-border">
          <button
            onClick={() => setActiveTab('actions')}
            className={`px-4 py-2 font-medium transition-colors ${
              activeTab === 'actions' ?'text-primary border-b-2 border-primary' :'text-muted-foreground hover:text-foreground'
            }`}
          >
            الإجراءات
          </button>
          <button
            onClick={() => setActiveTab('templates')}
            className={`px-4 py-2 font-medium transition-colors ${
              activeTab === 'templates' ?'text-primary border-b-2 border-primary' :'text-muted-foreground hover:text-foreground'
            }`}
          >
            القوالب
          </button>
          <button
            onClick={() => setActiveTab('fields')}
            className={`px-4 py-2 font-medium transition-colors ${
              activeTab === 'fields' ?'text-primary border-b-2 border-primary' :'text-muted-foreground hover:text-foreground'
            }`}
          >
            الحقول
          </button>
        </div>

        {activeTab === 'actions' && (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-3">
              {actions?.map((action) => (
                <button
                  key={action?.id}
                  onClick={() => handleAction(action?.id)}
                  className="p-4 rounded-lg border border-border hover:border-primary transition-all text-right group"
                >
                  <div className="flex items-center gap-3">
                    <div
                      className="w-10 h-10 rounded-lg flex items-center justify-center"
                      style={{ backgroundColor: `${action?.color}20` }}
                    >
                      <Icon name={action?.icon} size={20} color={action?.color} />
                    </div>
                    <span className="text-sm font-medium text-foreground group-hover:text-primary">
                      {action?.label}
                    </span>
                  </div>
                </button>
              ))}
            </div>

            <div className="bg-muted/50 rounded-lg p-4 space-y-3">
              <h3 className="text-sm font-semibold text-foreground flex items-center gap-2">
                <Icon name="Sparkles" size={16} />
                خيارات الذكاء الاصطناعي
              </h3>
              <div className="space-y-2">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={formData?.aiSuggest}
                    onChange={(e) => handleInputChange('aiSuggest', e?.target?.checked)}
                    className="w-4 h-4 rounded border-border"
                  />
                  <span className="text-sm text-foreground">اقتراحات ذكية للعقارات</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={formData?.autoMatch}
                    onChange={(e) => handleInputChange('autoMatch', e?.target?.checked)}
                    className="w-4 h-4 rounded border-border"
                  />
                  <span className="text-sm text-foreground">مطابقة تلقائية</span>
                </label>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'templates' && (
          <div className="space-y-3">
            {templates?.map((template) => (
              <div
                key={template?.id}
                className="p-4 rounded-lg border border-border hover:border-primary transition-all cursor-pointer"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <h4 className="text-sm font-semibold text-foreground">{template?.name}</h4>
                    <p className="text-xs text-muted-foreground mt-1">
                      {template?.fields?.length} حقول مخصصة
                    </p>
                  </div>
                  <Button variant="outline" size="sm">
                    استخدام
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}

        {activeTab === 'fields' && (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <Input
                label="اسم العميل"
                value={formData?.clientName}
                onChange={(e) => handleInputChange('clientName', e?.target?.value)}
                placeholder="الاسم الكامل"
              />
              <div>
                <label className="block text-sm font-medium text-foreground mb-2">نوع العميل</label>
                <select
                  value={formData?.clientType}
                  onChange={(e) => handleInputChange('clientType', e?.target?.value)}
                  className="w-full px-3 py-2 rounded-lg border border-border bg-background text-foreground"
                >
                  <option value="buyer">مشتري</option>
                  <option value="renter">مستأجر</option>
                  <option value="investor">مستثمر</option>
                  <option value="seller">بائع</option>
                </select>
              </div>
              <Input
                label="رقم الهاتف"
                value={formData?.phone}
                onChange={(e) => handleInputChange('phone', e?.target?.value)}
                placeholder="05xxxxxxxx"
              />
              <Input
                label="البريد الإلكتروني"
                type="email"
                value={formData?.email}
                onChange={(e) => handleInputChange('email', e?.target?.value)}
                placeholder="example@email.com"
              />
              <Input
                label="الميزانية"
                type="number"
                value={formData?.budget}
                onChange={(e) => handleInputChange('budget', e?.target?.value)}
                placeholder="0"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">التفضيلات والمتطلبات</label>
              <textarea
                value={formData?.preferences}
                onChange={(e) => handleInputChange('preferences', e?.target?.value)}
                placeholder="تفاصيل متطلبات العميل..."
                rows={4}
                className="w-full px-3 py-2 rounded-lg border border-border bg-background text-foreground resize-none"
              />
            </div>
          </div>
        )}

        <div className="flex justify-end gap-3 pt-4 border-t border-border">
          <Button variant="outline" onClick={onClose}>
            إلغاء
          </Button>
          <Button variant="default">
            حفظ
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ClientIntakeActionsModal;